import { Link } from "react-router-dom";
import WriteToUs from "../../../Components/WriteToUs";
import Image from '../../../assets/images/cloud-services.jpg'
import HelmetSco from "../../HelmetSco";

const FIreStore = () => {
  const handleButtonClick = () => {
    const scrollToElement = (id) => {
      const element = document.querySelector(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    scrollToElement('#id1');
  };
  const backgroundUrl =
    "https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/03/Firestore.webp";
  const title = "FireStore Integration by Alphai | Real-Time Cloud Databases";
  const description = "Explore FireStore database services with Alphai to enable real-time data synchronization and cloud integration for modern applications."
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": window.location.href,
  };
  const localBusinessJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Alphai Solutions",
    "description": "Alphai Solutions is a tech company offering IT consulting, software development, and digital transformation services in Pakistan.",
    "url": "https://www.alphaisolutions.com/",
    "image": "https://www.alphaisolutions.com/logo.png",
    "logo": "https://www.alphaisolutions.com/logo.png",
    "telephone": "+92 333 5489960",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Block A Plaza# 1, Next to Askari Bank, Valencia Town, Commercial Market",
      "addressLocality": "Lahore",
      "addressRegion": "Punjab",
      "postalCode": "54000",
      "addressCountry": "PK"
    },
    "openingHours": [
      "Mo-Fr 09:00-18:00"
    ],
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "31.3949",
      "longitude": "74.2352"
    },
    "sameAs": [
      "https://www.facebook.com/alphaisolutions",
      "https://www.linkedin.com/company/alphai-solutions",
      "https://www.instagram.com/alphaisolutions"
    ],
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Ali Raza"
        },
        "datePublished": "2024-11-10",
        "reviewBody": "Excellent service and professional team. Highly recommended for software development projects.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Sarah Khan"
        },
        "datePublished": "2025-01-15",
        "reviewBody": "Great experience working with Alphai Solutions on our e-commerce platform. Delivered on time!",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.8",
          "bestRating": "5"
        }
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "57"
    },
    "priceRange": "$$",
    "founder": {
      "@type": "Person",
      "name": "Your Name Here"
    },
    "foundingDate": "2020-01-10",
    "employee": {
      "@type": "OrganizationRole",
      "roleName": "Software Developer"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Pakistan"
    },
    "makesOffer": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "IT Consulting",
          "description": "Expert advice for digital transformation and technology planning."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Web & App Development",
          "description": "Custom websites and mobile apps built for performance and scalability."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "UI/UX Design",
          "description": "Creating engaging and intuitive user experiences across platforms."
        }
      }
    ]
  };
  

    const webPageJsonLd = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": title,
      "description": description,
      "url": window.location.href,
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": Image
      },
      "about": localBusinessJsonLd
    };
  return (
    <div>
      <HelmetSco title={title} description={description} imag={Image} jsonLd={webPageJsonLd} />
      <section
        className="mainBanner-module--main_banner--b7162"
        style={{ backgroundImage: `url(${Image})` }}
      >
        <div className="container">
          <div className="mainBanner-module--banner_wrap--7f8d1">
            <div className="mainBanner-module--banner_info--c335d">
              <h1
                className="mainBanner-module--ptSans--746de"
                data-aos="fade-up"
                data-aos-delay="50"
              >
                <span>Firestore</span> Database Development
              </h1>
              {/* <Link
                
                className="linkButtonRed-module--btn_red--0ea81 undefined"
                to="/contactus"
              >
                Get Started
              </Link> */}
            </div>
          </div>
        </div>
      </section>
      <section
        className="serviceDescription-module--service_description--22be0"
        data-aos="fade-up"
        data-aos-delay="50"
      >
        <div className="container">
          <div className="serviceDescription-module--row--d947b">
            <p>
              We hold expertise in developing applications using the Google
              Cloud Firestore NoSQL database management system. Alphai has
              expertise in Firestore development tools and frameworks such as
              Firebase Authentication, Cloud Functions, and Cloud Messaging. As
              a Firestore app development company, we provide services such as
              application development, integration, testing, and deployment to
              help organizations to manage their data effectively using
              Firestore.
            </p>
          </div>
        </div>
      </section>
      <section className="features-module--features_section--26167">
        <div className="container">
          <div className="features-module--features_wrap--87d7d">
            <div className="features-module--features_swipe--0c4c8">
              <span data-aos="fade-up" data-aos-delay="50">
                Features
              </span>
              <h2 data-aos="fade-up" data-aos-delay="100">
                Firestore development{" "}
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Firestore is a cloud-based NoSQL document database provided by
                Google as part of the Firebase platform. Firestore allows
                developers to store and sync data in real-time across multiple
                devices and platforms. It supports both web and mobile
                applications, and it provides a flexible and scalable solution
                for storing and querying data.
              </p>
            </div>
            <div
              className="features-module--features_swipe--0c4c8"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <div className="features-module--features_row--686e7">
                <div className="features-module--features_col--9b04d">
                  <div className="features-module--features_box--6d3b1">
                    <i className="features-module--features_icon--7b5fa">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M37.8178 18.3397L31.3309 12.4647C31.1971 12.3437 31.0312 12.2638 30.8531 12.2348C30.6751 12.2057 30.4924 12.2286 30.327 12.3008C30.1617 12.373 30.0206 12.4914 29.9209 12.6417C29.8212 12.7921 29.7669 12.968 29.7647 13.1484L29.7322 15.7672C28.7589 15.7903 27.7903 15.9105 26.8409 16.1259C25.6802 16.4006 24.5497 16.7898 23.4659 17.2878V12.9378H26.1341C26.3106 12.9378 26.4836 12.8879 26.6331 12.7938C26.7825 12.6998 26.9024 12.5655 26.9789 12.4063C27.0553 12.2472 27.0853 12.0697 27.0653 11.8942C27.0453 11.7188 26.9762 11.5526 26.8659 11.4147L20.7572 3.78156C20.6694 3.67179 20.558 3.58318 20.4313 3.52227C20.3046 3.46136 20.1659 3.42972 20.0253 3.42969C19.8847 3.42979 19.7459 3.46153 19.6192 3.52255C19.4925 3.58357 19.3812 3.67231 19.2934 3.78219L13.1941 11.4159C13.0841 11.5539 13.0153 11.72 12.9955 11.8953C12.9758 12.0706 13.0059 12.2479 13.0824 12.4069C13.1589 12.5659 13.2787 12.7 13.428 12.7939C13.5774 12.8878 13.7501 12.9377 13.9266 12.9378H16.5941V17.3128C15.4912 16.802 14.3395 16.4042 13.1566 16.1253C12.2102 15.9105 11.2448 15.7907 10.2747 15.7678L10.2422 13.1491C10.2399 12.9686 10.1857 12.7927 10.086 12.6424C9.98621 12.492 9.84519 12.3736 9.67983 12.3015C9.51447 12.2293 9.3318 12.2063 9.15372 12.2354C8.97565 12.2645 8.80975 12.3443 8.67593 12.4653L2.18468 18.3403C2.08553 18.4297 2.00662 18.5393 1.95323 18.6616C1.89984 18.784 1.8732 18.9164 1.87509 19.0498C1.87699 19.1833 1.90737 19.3149 1.96421 19.4357C2.02105 19.5565 2.10303 19.6638 2.20468 19.7503L8.8353 25.4066C8.97147 25.5228 9.13808 25.5977 9.31544 25.6222C9.49279 25.6468 9.67347 25.6201 9.83611 25.5452C9.99875 25.4703 10.1365 25.3504 10.2332 25.1997C10.3299 25.049 10.3813 24.8737 10.3816 24.6947L10.3853 22.1322C11.7778 22.2448 13.1229 22.6905 14.3072 23.4316L14.3784 23.4778C15.0685 23.9292 15.6335 24.5476 16.0208 25.2756C16.4081 26.0036 16.6053 26.8176 16.5941 27.6422V35.6334C16.5941 35.8821 16.6928 36.1205 16.8686 36.2964C17.0445 36.4722 17.2829 36.5709 17.5316 36.5709H22.5272C22.7758 36.5709 23.0143 36.4722 23.1901 36.2964C23.3659 36.1205 23.4647 35.8821 23.4647 35.6334V27.5997C23.4585 26.7719 23.6601 25.9558 24.0511 25.2261C24.4422 24.4965 25.0101 23.8767 25.7028 23.4234C26.8866 22.6845 28.2305 22.2404 29.6216 22.1284L29.6253 24.6909C29.6256 24.8699 29.6772 25.0451 29.7739 25.1957C29.8706 25.3463 30.0084 25.4661 30.171 25.5409C30.3336 25.6157 30.5143 25.6424 30.6916 25.6178C30.8689 25.5932 31.0354 25.5184 31.1716 25.4022L37.7966 19.7459C37.8979 19.6594 37.9797 19.5523 38.0364 19.4317C38.0931 19.3111 38.1234 19.1798 38.1254 19.0465C38.1273 18.9133 38.1009 18.7812 38.0477 18.6589C37.9946 18.5367 37.916 18.4273 37.8172 18.3378L37.8178 18.3397ZM31.5009 22.6609V21.1572C31.5009 20.9107 31.4039 20.6741 31.2308 20.4987C31.0577 20.3232 30.8224 20.223 30.5759 20.2197C28.491 20.1848 26.4406 20.7542 24.6722 21.8591C23.7158 22.4775 22.932 23.3284 22.3939 24.3321C21.8558 25.3358 21.581 26.4597 21.5953 27.5984V34.6959H18.4691V27.6384C18.4811 26.4998 18.2055 25.3765 17.6678 24.3727C17.13 23.369 16.3475 22.5173 15.3928 21.8966L15.3003 21.8372C13.5421 20.7467 11.5071 20.1856 9.43843 20.2209C9.19196 20.2242 8.9567 20.3244 8.78358 20.4999C8.61046 20.6754 8.51341 20.9119 8.51343 21.1584V22.6628L4.23343 19.0141L8.3928 15.2503L8.41093 16.7209C8.41242 16.8457 8.43878 16.9688 8.48847 17.0832C8.53816 17.1976 8.61017 17.301 8.7003 17.3872C8.78986 17.4744 8.89634 17.5424 9.01319 17.5869C9.13004 17.6314 9.25477 17.6515 9.37968 17.6459C10.5074 17.6023 11.6361 17.7057 12.7372 17.9534C14.2548 18.317 15.7139 18.8913 17.0722 19.6597C17.2149 19.7399 17.376 19.7813 17.5397 19.7799C17.7034 19.7785 17.8638 19.7342 18.0051 19.6516C18.1463 19.5689 18.2635 19.4507 18.3449 19.3087C18.4263 19.1667 18.4691 19.0059 18.4691 18.8422V12.0003C18.4691 11.7517 18.3703 11.5132 18.1945 11.3374C18.0187 11.1616 17.7802 11.0628 17.5316 11.0628H15.8759L20.0259 5.86906L24.1822 11.0628H22.5272C22.2785 11.0628 22.0401 11.1616 21.8643 11.3374C21.6884 11.5132 21.5897 11.7517 21.5897 12.0003V18.8128C21.5898 18.9763 21.6326 19.1369 21.7139 19.2788C21.7953 19.4206 21.9123 19.5387 22.0533 19.6213C22.1944 19.7039 22.3546 19.7482 22.5181 19.7498C22.6816 19.7514 22.8427 19.7102 22.9853 19.6303C24.3262 18.877 25.7648 18.3127 27.2603 17.9534C28.3641 17.7052 29.4955 17.6018 30.6259 17.6459C30.7507 17.6514 30.8753 17.6312 30.992 17.5867C31.1088 17.5422 31.2152 17.4743 31.3047 17.3872C31.3949 17.301 31.4671 17.1977 31.5168 17.0833C31.5666 16.9689 31.5931 16.8457 31.5947 16.7209L31.6128 15.2516L35.7678 19.0141L31.5009 22.6609Z"
                          fill="#323232"
                        ></path>
                      </svg>
                    </i>
                    <h4>Flexibility</h4>
                  </div>
                </div>
                <div className="features-module--features_col--9b04d">
                  <div className="features-module--features_box--6d3b1">
                    <i className="features-module--features_icon--7b5fa">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_650_8556)">
                          <mask
                            id="mask0_650_8556"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="40"
                            height="40"
                          >
                            <path
                              d="M0 3.8147e-06H40V40H0V3.8147e-06Z"
                              fill="white"
                            ></path>
                          </mask>
                          <g mask="url(#mask0_650_8556)">
                            <path
                              d="M16.1719 35.8906C7.89742 34.613 1.5625 27.4603 1.5625 18.828C1.5625 9.2925 9.29258 1.56243 18.8281 1.56243C27.5687 1.56243 34.7923 8.05735 35.936 16.4843"
                              stroke="#323232"
                              stroke-width="2.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M18.8281 7.1875V18.8281L13.0469 24.6875"
                              stroke="#323232"
                              stroke-width="2.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M38.4365 31.0938C37.6655 35.2723 34.0031 38.4375 29.6016 38.4375C24.6396 38.4375 20.6172 34.4151 20.6172 29.4531C20.6172 24.4912 24.6396 20.4688 29.6016 20.4688C30.4407 20.4688 31.253 20.5838 32.0234 20.799"
                              stroke="#323232"
                              stroke-width="2.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                            ></path>
                            <path
                              d="M37.2578 24.2937L30.4302 31.0516C29.9719 31.5053 29.2331 31.5033 28.7772 31.0474L26.4766 28.7468"
                              stroke="#323232"
                              stroke-width="2.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </g>
                        </g>
                        <defs>
                          <clippath id="clip0_650_8556">
                            <rect width="40" height="40" fill="white"></rect>
                          </clippath>
                        </defs>
                      </svg>
                    </i>
                    <h4>Real-time updates</h4>
                  </div>
                </div>
                <div className="features-module--features_col--9b04d">
                  <div className="features-module--features_box--6d3b1">
                    <i className="features-module--features_icon--7b5fa">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_650_8524"
                          style={{ maskType: "luminance" }}
                          maskUnits="userSpaceOnUse"
                          x="1"
                          y="2"
                          width="37"
                          height="37"
                        >
                          <path d="M1 2H38V39H1V2Z" fill="white"></path>
                        </mask>
                        <g mask="url(#mask0_650_8524)">
                          <path
                            d="M36.9219 27.6563H12.3516V3.08594H36.9219V27.6563Z"
                            stroke="#323232"
                            stroke-width="2.05079"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M12.3477 21.875H2.08594V37.918H18.129V27.6563"
                            stroke="#323232"
                            stroke-width="2.05079"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                        <path
                          d="M28.2422 7.42188H32.5782V11.7578"
                          stroke="#323232"
                          stroke-width="2.05079"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M16.6797 18.9844V23.3204H21.0157"
                          stroke="#323232"
                          stroke-width="2.05079"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M32.5782 7.42188L16.6797 23.3204"
                          stroke="#323232"
                          stroke-width="2.05079"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    </i>
                    <h4>Scalable</h4>
                  </div>
                </div>
                <div className="features-module--features_col--9b04d">
                  <div className="features-module--features_box--6d3b1">
                    <i className="features-module--features_icon--7b5fa">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M35.9364 19.7761C34.7996 18.8392 33.0028 18.7589 31.8235 20.0245L28.8958 23.1673C28.5173 21.9508 27.3812 21.065 26.0419 21.065H20.8174C20.4209 21.065 20.2882 20.9136 19.5996 20.3831C16.974 18.0942 13.0304 18.1015 10.4128 20.405L8.49246 22.0956C7.62924 21.6387 6.62126 21.6274 5.75334 22.061L3.55077 23.162C3.0587 23.4083 2.85955 24.0066 3.10519 24.4987L9.08142 36.4511C9.32778 36.9431 9.92604 37.1423 10.4181 36.8966L12.6207 35.795C13.7063 35.2526 14.3106 34.1449 14.2714 33.0175H26.0418C28.2245 33.0175 30.3102 31.9749 31.6196 30.2286L36.4013 23.8527C37.3289 22.6169 37.1821 20.8047 35.9364 19.7761ZM11.7295 34.0134L10.418 34.6694L5.33232 24.4987L6.64444 23.8426C7.13651 23.5969 7.7341 23.7955 7.98047 24.2882L12.1751 32.6775C12.4208 33.1695 12.2216 33.7671 11.7295 34.0134ZM34.8076 22.6574L30.026 29.0333C29.0904 30.281 27.601 31.0253 26.0419 31.0253H13.5762L9.84369 23.5598L11.7288 21.9004C13.6047 20.2503 16.4334 20.2503 18.3093 21.9004C19.4142 22.8732 20.1015 23.0571 20.8173 23.0571H26.0418C26.591 23.0571 27.0379 23.504 27.0379 24.0532C27.0379 24.6023 26.5909 25.0492 26.0418 25.0492H20.9548C20.4049 25.0492 19.9588 25.4954 19.9588 26.0452C19.9588 26.595 20.405 27.0412 20.9548 27.0412H26.7092C27.5359 27.0412 28.3328 26.6946 28.8958 26.0897L33.281 21.3824C33.6821 20.9521 34.297 20.988 34.6742 21.318C35.0686 21.6633 35.1111 22.2536 34.8076 22.6574Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M23.94 9.79694C24.622 9.08181 25.0423 8.115 25.0423 7.05051C25.0423 4.85791 23.2707 3 21.0582 3C18.8623 3 17.0077 4.85459 17.0077 7.05051C17.0077 8.0824 17.4121 9.05651 18.1465 9.80491C16.3251 10.8262 15.0156 12.7863 15.0156 15.0852V16.0812C15.0156 16.631 15.4619 17.0773 16.0117 17.0773H26.0384C26.5882 17.0773 27.0344 16.631 27.0344 16.0812V15.0852C27.0344 12.8315 25.7948 10.8408 23.94 9.79694ZM21.0582 4.99212C22.1379 4.99212 23.0502 5.93502 23.0502 7.05058C23.0502 8.14887 22.1565 9.04263 21.0582 9.04263C19.9426 9.04263 18.9997 8.13028 18.9997 7.05058C18.9997 5.95428 19.9619 4.99212 21.0582 4.99212ZM17.0077 15.0852C17.0077 12.8893 18.8623 11.0347 21.0582 11.0347C23.2548 11.0347 25.0423 12.8514 25.0423 15.0852H17.0077Z"
                          fill="#323232"
                        ></path>
                      </svg>
                    </i>
                    <h4>Offline support</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services-module--services--13268 hirepage_hire-service-section">
        <div className="container">
          <div className="services-module--services_wrap--2ed4d">
            <div className="services-module--services_heading--9668c">
              <span data-aos="fade-up" data-aos-delay="50">
                Services
              </span>
              <h2 data-aos="fade-up" data-aos-delay="100">
                Firestore database development services
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Building scalable and secure cloud-based applications with our
                Firestore development services
              </p>
            </div>
            <ul
              className="services-module--development_listing--4253c"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <li>
                <div className="services-module--development_col--17e9b">
                  <i>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_650_8701)">
                        <path
                          d="M34.0117 3.0625H5.98828C4.34054 3.0625 3 4.40304 3 6.05078V33.9414C3 35.5891 4.34054 36.9297 5.98828 36.9297H34.0117C35.6595 36.9297 37 35.5891 37 33.9414V6.05078C37 4.40304 35.6595 3.0625 34.0117 3.0625ZM5.98828 5.05469H34.0117C34.561 5.05469 35.0078 5.50154 35.0078 6.05078V11.0312H4.99219V6.05078C4.99219 5.50154 5.43904 5.05469 5.98828 5.05469ZM34.0117 34.9375H5.98828C5.43904 34.9375 4.99219 34.4907 4.99219 33.9414V13.0234H35.0078V33.9414C35.0078 34.4907 34.561 34.9375 34.0117 34.9375Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M23.3809 16.0964C22.8753 15.8797 22.2897 16.1139 22.073 16.6196L16.0964 30.5649C15.8797 31.0705 16.114 31.6561 16.6196 31.8728C17.1254 32.0896 17.7109 31.8551 17.9275 31.3497L23.9041 17.4043C24.1208 16.8987 23.8866 16.3131 23.3809 16.0964Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M14.801 19.3738C14.4573 18.9443 13.8303 18.8747 13.401 19.2183L8.42048 23.2027C7.9225 23.6009 7.92217 24.3598 8.42048 24.7583L13.401 28.7427C13.8305 29.0864 14.4575 29.0167 14.801 28.5872C15.1446 28.1576 15.0751 27.5307 14.6454 27.1871L10.6373 23.9805L14.6454 20.774C15.0751 20.4303 15.1446 19.8035 14.801 19.3738Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M31.5754 23.2027L26.5949 19.2184C26.1653 18.8746 25.5385 18.9443 25.1949 19.3739C24.8512 19.8035 24.9208 20.4303 25.3505 20.7739L29.3586 23.9805L25.3505 27.1871C24.9208 27.5308 24.8512 28.1576 25.1949 28.5871C25.539 29.0172 26.1659 29.086 26.5949 28.7427L31.5754 24.7583C32.0734 24.3601 32.0737 23.6013 31.5754 23.2027Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M8.04297 9.03906C8.5931 9.03906 9.03906 8.5931 9.03906 8.04297C9.03906 7.49284 8.5931 7.04688 8.04297 7.04688C7.49284 7.04688 7.04688 7.49284 7.04688 8.04297C7.04688 8.5931 7.49284 9.03906 8.04297 9.03906Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M12.0273 9.03906C12.5775 9.03906 13.0234 8.5931 13.0234 8.04297C13.0234 7.49284 12.5775 7.04688 12.0273 7.04688C11.4772 7.04688 11.0312 7.49284 11.0312 8.04297C11.0312 8.5931 11.4772 9.03906 12.0273 9.03906Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M16.0117 9.03906C16.5618 9.03906 17.0078 8.5931 17.0078 8.04297C17.0078 7.49284 16.5618 7.04688 16.0117 7.04688C15.4616 7.04688 15.0156 7.49284 15.0156 8.04297C15.0156 8.5931 15.4616 9.03906 16.0117 9.03906Z"
                          fill="#323232"
                        ></path>
                        <path
                          d="M25.9805 9.03906H31.957C32.5071 9.03906 32.9531 8.59308 32.9531 8.04297C32.9531 7.49286 32.5071 7.04688 31.957 7.04688H25.9805C25.4304 7.04688 24.9844 7.49286 24.9844 8.04297C24.9844 8.59308 25.4304 9.03906 25.9805 9.03906Z"
                          fill="#323232"
                        ></path>
                      </g>
                      <defs>
                        <clippath id="clip0_650_8701">
                          <rect
                            width="34"
                            height="34"
                            fill="white"
                            transform="translate(3 3)"
                          ></rect>
                        </clippath>
                      </defs>
                    </svg>
                  </i>
                  <h3>Firestore-based web apps development</h3>
                  <p>
                    <p>
                      We develop web applications using Google’s Firebase Cloud
                      Firestore as the backend database. Firestore-based{" "}
                      <a href="/services/mobile-app-development/">
                        web app development
                      </a>{" "}
                      involves building scalable, real-time applications with
                      offline capabilities and cloud synchronization.
                    </p>
                  </p>
                </div>
              </li>
              <li>
                <div className="services-module--development_col--17e9b">
                  <i>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 30.2001L12.1345 3.65947C12.2464 2.92493 13.1948 2.75139 13.5295 3.40801L17.0068 10.1691L8 30.2001ZM8 30.2001L27.5491 10.1691C27.6469 10.0696 27.769 9.99977 27.9022 9.9672C28.0354 9.93464 28.1747 9.94057 28.3049 9.98435C28.4351 10.0281 28.5513 10.1081 28.6409 10.2156C28.7305 10.323 28.7901 10.4539 28.8132 10.5941L32 30.2001L21.0411 36.7104C20.7077 36.9004 20.3336 37 19.9533 37C19.573 37 19.1989 36.9004 18.8655 36.7104L8 30.2001ZM8 30.2001L19.3495 8.19849C19.4115 8.07195 19.5059 7.96569 19.6224 7.89147C19.7389 7.81725 19.8729 7.77796 20.0095 7.77796C20.1462 7.77796 20.2802 7.81725 20.3967 7.89147C20.5132 7.96569 20.6076 8.07195 20.6695 8.19849L23.1609 13.1243L8 30.2001Z"
                        stroke="#323232"
                        stroke-width="2"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </i>
                  <h3>Firestore consulting services</h3>
                  <p>
                    <p>
                      Avail consulting services our Firestore experts provide to
                      help you with database design, optimization, and
                      troubleshooting. Firestore consulting services help
                      organizations optimize their database performance,
                      scalability, and reduce costs.
                    </p>
                  </p>
                </div>
              </li>
              <li>
                <div className="services-module--development_col--17e9b">
                  <i>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.8855 8.70635L11.2678 7.08863C11.0162 6.83704 10.6495 6.7387 10.3057 6.83086L8.09593 7.42296C7.75224 7.51506 7.48371 7.78352 7.39168 8.12721L6.79959 10.337C6.70749 10.6807 6.80576 11.0475 7.05735 11.2991L8.67501 12.9169C8.9262 13.1681 9.2926 13.267 9.63709 13.1747L11.847 12.5826C12.1907 12.4905 12.4592 12.222 12.5512 11.8783L13.1433 9.6685C13.2354 9.32481 13.1371 8.95801 12.8855 8.70635ZM10.7759 10.8072L9.677 11.1016L8.87262 10.2972L9.16697 9.19838L10.2658 8.9039L11.0703 9.70834L10.7759 10.8072Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M33.034 28.8704L31.4163 27.2526C31.1647 27.001 30.7978 26.9028 30.4542 26.9949L28.2444 27.587C27.9007 27.6791 27.6322 27.9475 27.5401 28.2912L26.948 30.501C26.8559 30.8447 26.9543 31.2115 27.2058 31.4631L28.8236 33.0808C29.0742 33.3315 29.4406 33.4311 29.7856 33.3386L31.9955 32.7465C32.3392 32.6544 32.6076 32.3859 32.6997 32.0423L33.2918 29.8324C33.3839 29.4887 33.2856 29.122 33.034 28.8704ZM30.9244 30.9711L29.8254 31.2656L29.021 30.4612L29.3155 29.3623L30.4144 29.0679L31.2188 29.8723L30.9244 30.9711Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M30.0249 23.0528C29.6324 23.0528 29.2372 23.0925 28.8104 23.176L25.6327 19.9983L28.7959 16.835C31.0259 17.2314 33.3402 16.5166 34.9551 14.9016C37.0412 12.8155 37.5888 9.62621 36.3177 6.9654C36.1782 6.67363 35.906 6.46772 35.5873 6.41307C35.2685 6.35829 34.9432 6.46181 34.7146 6.6905L32.1379 9.26724C31.7494 9.65569 31.1177 9.65562 30.7292 9.26724C30.3409 8.87887 30.3409 8.247 30.7292 7.85862L33.3061 5.2818C33.5347 5.05319 33.6381 4.72782 33.5835 4.40916C33.5288 4.09051 33.3229 3.8182 33.0312 3.67882C30.3703 2.40765 27.1809 2.95519 25.0948 5.04137C23.4798 6.65637 22.7651 8.9711 23.1615 11.2005L19.9982 14.3638L16.8349 11.2005C17.2312 8.9711 16.5166 6.6563 14.9016 5.04137C12.1832 2.32292 7.75975 2.32292 5.04143 5.04137C2.32292 7.75981 2.32292 12.1832 5.04143 14.9016C6.65643 16.5166 8.97103 17.2314 11.2004 16.8349L14.3638 19.9982L11.2005 23.1615C8.97097 22.7653 6.65623 23.4799 5.04137 25.0949C2.95519 27.181 2.40765 30.3703 3.67882 33.0312C3.8182 33.3229 4.09051 33.5288 4.40916 33.5835C4.72776 33.6381 5.05319 33.5347 5.2818 33.3061L7.85855 30.7293C8.24693 30.3409 8.8788 30.3409 9.26718 30.7293C9.65556 31.1177 9.65549 31.7496 9.26718 32.1379L6.69043 34.7147C6.46181 34.9433 6.35836 35.2687 6.41301 35.5873C6.46766 35.906 6.67363 36.1783 6.96533 36.3177C9.6373 37.5942 12.8244 37.0323 14.9016 34.9551C16.5166 33.3401 17.2312 31.0253 16.8349 28.7959L19.9982 25.6326L23.176 28.8103C23.0925 29.237 23.0528 29.6324 23.0528 30.0249C23.0528 33.8693 26.1805 36.9971 30.025 36.9971C33.8695 36.9971 36.9972 33.8693 36.9972 30.0249C36.9972 26.1804 33.8695 23.0528 30.0249 23.0528ZM12.2233 15.0407C11.9719 14.7893 11.6055 14.6909 11.262 14.7826C9.54713 15.2406 7.70337 14.7465 6.44999 13.4931C4.50817 11.5513 4.50817 8.39182 6.44999 6.45006C8.39175 4.5083 11.5512 4.5083 13.493 6.45006C14.7463 7.70337 15.2405 9.54732 14.7825 11.2622C14.6908 11.6057 14.7891 11.972 15.0405 12.2235L18.5896 15.7725L15.7723 18.5897L12.2233 15.0407ZM19.2941 23.5198L19.294 23.5198L19.2939 23.5199L15.0405 27.7732C14.7891 28.0246 14.6908 28.3909 14.7825 28.7345C15.2404 30.4494 14.7463 32.2932 13.493 33.5466C12.3664 34.6731 10.7899 35.1716 9.26658 34.9559L10.6758 33.5466C11.8409 32.3816 11.8409 30.4859 10.6758 29.3208C9.51087 28.1558 7.61506 28.1557 6.44999 29.3208L5.04077 30.7301C4.82497 29.2067 5.32357 27.6301 6.44999 26.5036C7.70337 25.2503 9.54726 24.756 11.2621 25.2141C11.6058 25.306 11.9719 25.2076 12.2234 24.9561L16.4766 20.703L16.4768 20.7028L16.477 20.7026L20.7025 16.477L20.7027 16.477L20.7027 16.4768L24.956 12.2236C25.2074 11.9722 25.3058 11.6059 25.2141 11.2623C24.7562 9.54746 25.2502 7.70357 26.5036 6.45019C27.6301 5.3237 29.2066 4.82497 30.73 5.0409L29.3207 6.45019C28.1557 7.61519 28.1557 9.51094 29.3207 10.676C30.4885 11.8438 32.3787 11.8439 33.5466 10.676L34.9559 9.26671C35.1716 10.7901 34.6731 12.3667 33.5466 13.4932C32.2932 14.7465 30.4491 15.2407 28.7344 14.7827C28.3909 14.6909 28.0246 14.7893 27.7731 15.0407L23.52 19.2938L23.5198 19.294L23.5196 19.2942L19.2941 23.5198ZM30.0249 35.0052C27.2789 35.0052 25.0447 32.7711 25.0447 30.025C25.0447 29.6413 25.1046 29.2369 25.2334 28.7524C25.3246 28.4092 25.2261 28.0435 24.975 27.7924L21.4067 24.2242L24.224 21.4069L27.7922 24.9751C28.0432 25.2262 28.4087 25.3246 28.7522 25.2335C29.2368 25.1048 29.6412 25.0449 30.0248 25.0449C32.7709 25.0449 35.005 27.279 35.005 30.0251C35.0051 32.7711 32.7711 35.0052 30.0249 35.0052Z"
                        fill="#323232"
                      ></path>
                    </svg>
                  </i>
                  <h3>Firestore maintenance &amp; support</h3>
                  <p>
                    <p>
                      We offer ongoing support and maintenance services for
                      Firestore databases. These services can help organizations
                      ensure optimal database performance, reduce downtime, and
                      address any issues that arise in the database.
                    </p>
                  </p>
                </div>
              </li>
              <li>
                <div className="services-module--development_col--17e9b">
                  <i>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M34.8359 2H5.16406C3.4194 2 2 3.42496 2 5.17647V30.5882C2 32.3397 3.4194 33.7647 5.16406 33.7647C11.4581 33.7647 10.8937 33.7658 10.9736 33.7624L13.2882 36.0861C13.6996 36.4993 14.368 36.4996 14.7797 36.0861L15.9079 34.9534C16.2103 35.0988 16.52 35.2278 16.8359 35.34V36.9412C16.8359 37.5259 17.3081 38 17.8906 38H22.1093C22.6918 38 23.164 37.5259 23.164 36.9412V35.34C23.4799 35.2278 23.7896 35.0988 24.092 34.9534L25.2201 36.0861C25.6316 36.4993 26.2999 36.4996 26.7117 36.0861L29.0241 33.7647H34.8359C36.5806 33.7647 38 32.3397 38 30.5882V5.17647C38 3.42496 36.5806 2 34.8359 2ZM5.16406 4.11765H34.8359C35.4175 4.11765 35.8906 4.59264 35.8906 5.17647V10.4706H4.10938V5.17647C4.10938 4.59264 4.58251 4.11765 5.16406 4.11765ZM25.966 33.84L25.0314 32.9016C24.6907 32.5596 24.1624 32.4929 23.7481 32.7393C23.1542 33.0924 22.5145 33.3588 21.8468 33.5312C21.3806 33.6515 21.0547 34.0735 21.0547 34.5567V35.8824H18.9453V34.5567C18.9453 34.0735 18.6194 33.6516 18.1532 33.5313C17.4855 33.359 16.8458 33.0925 16.2519 32.7393C15.8374 32.4928 15.3092 32.5597 14.9686 32.9017L14.034 33.84L12.5422 32.3424L13.4768 31.404C13.8175 31.0621 13.884 30.5319 13.6385 30.1158C13.2868 29.5195 13.0214 28.8773 12.8497 28.207C12.73 27.7389 12.3096 27.4118 11.8283 27.4118H10.5078V25.2941H11.8283C12.3096 25.2941 12.7299 24.9669 12.8497 24.4989C13.0213 23.8286 13.2868 23.1864 13.6385 22.5901C13.884 22.174 13.8175 21.6438 13.4768 21.3019L12.5422 20.3635L14.034 18.8659L14.9686 19.8042C15.3092 20.1462 15.8374 20.2129 16.2519 19.9665C16.8458 19.6134 17.4855 19.347 18.1532 19.1746C18.6194 19.0543 18.9453 18.6324 18.9453 18.1492V16.8235H21.0547V18.1492C21.0547 18.6324 21.3806 19.0543 21.8468 19.1746C22.5145 19.3469 23.1542 19.6134 23.7481 19.9665C24.1625 20.213 24.6907 20.1461 25.0314 19.8042L25.966 18.8659L27.4578 20.3635L26.5232 21.3019C26.1825 21.6438 26.116 22.174 26.3615 22.5901C26.7132 23.1864 26.9786 23.8286 27.1503 24.4989C27.2701 24.9669 27.6904 25.2941 28.1717 25.2941H29.4922V27.4118H28.1717C27.6904 27.4118 27.2701 27.7389 27.1503 28.207C26.9787 28.8773 26.7132 29.5195 26.3615 30.1158C26.116 30.5319 26.1825 31.0621 26.5232 31.404L27.4578 32.3424L25.966 33.84ZM34.8359 31.6471H29.7433C29.6899 31.5856 29.8042 31.703 28.5669 30.461C28.7118 30.1574 28.8402 29.8466 28.952 29.5294H30.5469C31.1293 29.5294 31.6016 29.0553 31.6016 28.4706V24.2353C31.6016 23.6505 31.1293 23.1765 30.5469 23.1765H28.9519C28.8402 22.8593 28.7117 22.5484 28.5669 22.2448L29.6951 21.1123C30.1067 20.6992 30.107 20.0282 29.6951 19.6149L26.7117 16.6197C26.3002 16.2065 25.6319 16.2062 25.2201 16.6197L24.092 17.7524C23.7896 17.607 23.4799 17.478 23.164 17.3659V15.7647C23.164 15.18 22.6918 14.7059 22.1093 14.7059H17.8906C17.3081 14.7059 16.8359 15.18 16.8359 15.7647V17.3659C16.52 17.4781 16.2103 17.6071 15.9079 17.7525L14.7797 16.6198C14.3682 16.2066 13.6999 16.2063 13.2882 16.6198L10.3047 19.6149C9.89314 20.028 9.89286 20.699 10.3047 21.1123L11.433 22.2449C11.2881 22.5485 11.1597 22.8594 11.048 23.1765H9.45312C8.87066 23.1765 8.39844 23.6506 8.39844 24.2354V28.4707C8.39844 29.0554 8.87066 29.5295 9.45312 29.5295H11.0481C11.1598 29.8466 11.2883 30.1575 11.4331 30.4611C10.1959 31.7031 10.3102 31.5856 10.2567 31.6471H5.16406C4.58251 31.6471 4.10938 31.1721 4.10938 30.5883V12.5882H35.8906V30.5882C35.8906 31.1721 35.4175 31.6471 34.8359 31.6471Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M20 21C17.243 21 15 23.243 15 26C15 28.757 17.243 31 20 31C22.757 31 25 28.757 25 26C25 23.243 22.757 21 20 21ZM20 29C18.3458 29 17 27.6542 17 26C17 24.3458 18.3458 23 20 23C21.6542 23 23 24.3458 23 26C23 27.6542 21.6542 29 20 29Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M7 8C7.55228 8 8 7.55228 8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M11 8C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M15 8C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6C14.4477 6 14 6.44772 14 7C14 7.55228 14.4477 8 15 8Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M26.125 8H32.875C33.4963 8 34 7.55227 34 7C34 6.44773 33.4963 6 32.875 6H26.125C25.5037 6 25 6.44773 25 7C25 7.55227 25.5037 8 26.125 8Z"
                        fill="#323232"
                      ></path>
                    </svg>
                  </i>
                  <h3>Firestore backend development</h3>
                  <p>
                    <p>
                      Alphai has expert DBAs to develop backend services and APIs
                      using Firestore as the primary database. Firestore backend
                      development involves developing serverless applications
                      that leverage Firestore’s real-time data synchronization
                      and offline capabilities.
                    </p>
                  </p>
                </div>
              </li>
              <li>
                <div className="services-module--development_col--17e9b">
                  <i>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_650_8721"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="2"
                        y="2"
                        width="36"
                        height="36"
                      >
                        <path d="M2 2H38V38H2V2Z" fill="white"></path>
                      </mask>
                      <g mask="url(#mask0_650_8721)">
                        <path
                          d="M5.62784 27.0469C2.06753 19.7892 4.49176 10.8662 11.4885 6.46844C16.5007 3.31806 22.5879 3.28911 27.4744 5.86242"
                          stroke="#323232"
                          stroke-width="2.5"
                          stroke-miterlimit="10"
                        ></path>
                        <path
                          d="M33.9288 12.1491C38.1167 19.5454 35.7834 29.0011 28.5131 33.5707C23.283 36.8581 16.8888 36.7408 11.9062 33.8178"
                          stroke="#323232"
                          stroke-width="2.5"
                          stroke-miterlimit="10"
                        ></path>
                        <path
                          d="M32.5397 7.2888C32.5397 8.82929 31.2908 10.0781 29.7503 10.0781C28.2098 10.0781 26.9609 8.82929 26.9609 7.2888C26.9609 5.7483 28.2098 4.49947 29.7503 4.49947C31.2908 4.49947 32.5397 5.7483 32.5397 7.2888Z"
                          stroke="#323232"
                          stroke-width="2.5"
                          stroke-miterlimit="10"
                        ></path>
                        <path
                          d="M12.3443 32.1638C12.3443 33.7043 11.0954 34.9531 9.55495 34.9531C8.01446 34.9531 6.76562 33.7043 6.76562 32.1638C6.76562 30.6233 8.01446 29.3745 9.55495 29.3745C11.0954 29.3745 12.3443 30.6233 12.3443 32.1638Z"
                          stroke="#323232"
                          stroke-width="2.5"
                          stroke-miterlimit="10"
                        ></path>
                        <path
                          d="M26.4333 25.0859C28.1959 25.0859 29.6232 23.6506 29.6101 21.8851C29.5971 20.1335 28.1452 18.7324 26.3934 18.7324H25.694C25.694 17.2195 24.4676 15.9929 22.9546 15.9929L22.6144 15.9962C22.6144 13.9511 20.92 12.2669 18.8749 12.2669C16.789 12.2669 15.0981 13.9578 15.0981 16.0437V16.5079H14.6718C12.3031 16.5079 10.3828 18.4282 10.3828 20.797C10.3828 23.1657 12.3031 25.0859 14.6718 25.0859H26.4333Z"
                          stroke="#323232"
                          stroke-width="2.5"
                          stroke-miterlimit="10"
                        ></path>
                      </g>
                    </svg>
                  </i>
                  <h3>Firestore cloud solution development</h3>
                  <p>
                    <p>
                      Our services refer to developing custom cloud solutions
                      using Firestore as the backend database. Our customized
                      Firestore cloud solutions involve building scalable,
                      secure, and high-performance applications that leverage
                      Firestore’s cloud infrastructure.
                    </p>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="yourProduct-module--who_we_serve--820ee hirepage_custom_whoweserce_section">
        <div className="container">
          <div className="yourProduct-module--serve_wrap--807a9">
            <div className="yourProduct-module--mix_heading--952f4">
              <span data-aos="fade-up" data-aos-delay="50">
                Your product your way
              </span>
              <h2 data-aos="fade-up" data-aos-delay="100">
                Our Engagement Model
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Comprehensive engagement models for your custom software needs
              </p>
            </div>
            <ul className="yourProduct-module--serve_listing--c2a28">
              <li
                data-aos="fade-up"
                data-aos-delay="0"
                className="yourProduct-module--serve_col--fd20d"
              >
                <i>
                  {" "}
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M34.1406 20.949H30.2252C29.6923 20.949 29.1763 21.0218 28.6853 21.1557C27.7167 19.2516 25.7392 17.9434 23.4605 17.9434H16.5395C14.2608 17.9434 12.2833 19.2516 11.3147 21.1557C10.8237 21.0218 10.3077 20.949 9.77484 20.949H5.85938C2.62852 20.949 0 23.5775 0 26.8084V33.0676C0 35.0061 1.57711 36.5832 3.51562 36.5832H36.4844C38.4229 36.5832 40 35.0061 40 33.0676V26.8084C40 23.5775 37.3715 20.949 34.1406 20.949ZM10.6801 23.8029V34.2395H3.51562C2.86945 34.2395 2.34375 33.7138 2.34375 33.0677V26.8084C2.34375 24.8699 3.92086 23.2928 5.85938 23.2928H9.77484C10.093 23.2928 10.401 23.336 10.6943 23.4156C10.6859 23.5438 10.6801 23.6727 10.6801 23.8029ZM26.9762 34.2395H13.0238V23.8028C13.0238 21.8643 14.6009 20.2872 16.5395 20.2872H23.4605C25.3991 20.2872 26.9762 21.8643 26.9762 23.8028V34.2395ZM37.6562 33.0677C37.6562 33.7138 37.1305 34.2395 36.4844 34.2395H29.3199V23.8028C29.3199 23.6726 29.3141 23.5437 29.3057 23.4155C29.599 23.336 29.907 23.2927 30.2252 23.2927H34.1406C36.0791 23.2927 37.6562 24.8698 37.6562 26.8084V33.0677Z"
                      fill="#323232"
                    ></path>
                    <path
                      d="M7.81805 9.88281C4.94703 9.88281 2.61133 12.2185 2.61133 15.0895C2.61125 17.9605 4.94703 20.2962 7.81805 20.2962C10.689 20.2962 13.0248 17.9605 13.0248 15.0895C13.0248 12.2185 10.6891 9.88281 7.81805 9.88281ZM7.81797 17.9525C6.2393 17.9525 4.955 16.6682 4.955 15.0895C4.955 13.5109 6.2393 12.2266 7.81797 12.2266C9.39664 12.2266 10.6809 13.5109 10.6809 15.0895C10.6809 16.6682 9.39664 17.9525 7.81797 17.9525Z"
                      fill="#323232"
                    ></path>
                    <path
                      d="M19.9991 3.41602C16.1634 3.41602 13.043 6.53648 13.043 10.3721C13.043 14.2077 16.1634 17.3282 19.9991 17.3282C23.8347 17.3282 26.9552 14.2077 26.9552 10.3721C26.9552 6.53656 23.8347 3.41602 19.9991 3.41602ZM19.9991 14.9845C17.4558 14.9845 15.3867 12.9154 15.3867 10.3721C15.3867 7.82891 17.4558 5.75977 19.9991 5.75977C22.5423 5.75977 24.6114 7.82883 24.6114 10.3721C24.6114 12.9154 22.5423 14.9845 19.9991 14.9845Z"
                      fill="#323232"
                    ></path>
                    <path
                      d="M32.1833 9.88281C29.3123 9.88281 26.9766 12.2185 26.9766 15.0895C26.9766 17.9605 29.3123 20.2962 32.1833 20.2962C35.0543 20.2962 37.39 17.9605 37.39 15.0895C37.39 12.2185 35.0543 9.88281 32.1833 9.88281ZM32.1833 17.9525C30.6047 17.9525 29.3203 16.6682 29.3203 15.0895C29.3204 13.5109 30.6047 12.2266 32.1833 12.2266C33.762 12.2266 35.0462 13.5109 35.0462 15.0895C35.0462 16.6682 33.762 17.9525 32.1833 17.9525Z"
                      fill="#323232"
                    ></path>
                  </svg>
                </i>
                <h3>Build Your Team</h3>
                <p>Get the best team with expert skills at affordable rates</p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-delay="200"
                className="yourProduct-module--serve_col--fd20d"
              >
                <i>
                  {" "}
                  <svg
                    width="40"
                    height="36"
                    viewBox="0 0 40 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M38.8354 5.10968C38.833 5.10968 38.8306 5.10938 38.8281 5.10938H28.2031V3.9375C28.2031 1.99902 26.626 0.421875 24.6875 0.421875H15.3125C13.374 0.421875 11.7969 1.99902 11.7969 3.9375V5.10938H1.17188C0.519409 5.10938 0 5.64404 0 6.28125V32.0625C0 34.001 1.57715 35.5781 3.51562 35.5781H36.4844C38.4229 35.5781 40 34.001 40 32.0625V6.30597C40 6.30444 40 6.30292 40 6.30139C39.9551 5.53174 39.4818 5.11395 38.8354 5.10968ZM14.1406 3.9375C14.1406 3.29144 14.6664 2.76562 15.3125 2.76562H24.6875C25.3336 2.76562 25.8594 3.29144 25.8594 3.9375V5.10938H14.1406V3.9375ZM37.2021 7.45312L33.5629 18.3705C33.4033 18.8499 32.9565 19.1719 32.4515 19.1719H25.8594V18C25.8594 17.3527 25.3348 16.8281 24.6875 16.8281H15.3125C14.6652 16.8281 14.1406 17.3527 14.1406 18V19.1719H7.54852C7.04346 19.1719 6.59668 18.8499 6.43707 18.3705L2.79785 7.45312H37.2021ZM23.5156 19.1719V21.5156H16.4844V19.1719H23.5156ZM37.6562 32.0625C37.6562 32.7086 37.1304 33.2344 36.4844 33.2344H3.51562C2.86957 33.2344 2.34375 32.7086 2.34375 32.0625V13.5026L4.21356 19.1118C4.69269 20.5497 6.03302 21.5156 7.54852 21.5156H14.1406V22.6875C14.1406 23.3348 14.6652 23.8594 15.3125 23.8594H24.6875C25.3348 23.8594 25.8594 23.3348 25.8594 22.6875V21.5156H32.4515C33.967 21.5156 35.3073 20.5497 35.7864 19.1118L37.6562 13.5026V32.0625Z"
                      fill="black"
                    ></path>
                  </svg>
                </i>
                <h3>Dedicated Hiring</h3>
                <p>Get dedicated resources as per your development needs</p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-delay="400"
                className="yourProduct-module--serve_col--fd20d"
              >
                <i>
                  {" "}
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.0005 22.856C20.7876 22.856 21.4291 23.4974 21.4291 24.2845C21.4291 25.0731 22.0676 25.7131 22.8576 25.7131C23.6476 25.7131 24.2862 25.0731 24.2862 24.2845C24.2862 22.4246 23.0876 20.8531 21.4291 20.2617V19.9989C21.4291 19.2103 20.7891 18.5703 20.0005 18.5703C19.212 18.5703 18.572 19.2103 18.572 19.9989V20.2617C16.9134 20.8531 15.7148 22.4246 15.7148 24.2845C15.7148 26.6474 17.6377 28.5702 20.0005 28.5702C20.7876 28.5702 21.4291 29.2116 21.4291 29.9988C21.4291 30.7859 20.7876 31.4273 20.0005 31.4273C19.2134 31.4273 18.572 30.7859 18.572 29.9988C18.572 29.2102 17.932 28.5702 17.1434 28.5702C16.3548 28.5702 15.7148 29.2102 15.7148 29.9988C15.7148 31.8587 16.9134 33.4302 18.572 34.0216V34.2844C18.572 35.073 19.212 35.713 20.0005 35.713C20.7891 35.713 21.4291 35.073 21.4291 34.2844V34.0216C23.0876 33.4302 24.2862 31.8587 24.2862 29.9988C24.2862 27.6359 22.3633 25.7131 20.0005 25.7131C19.2134 25.7131 18.572 25.0717 18.572 24.2845C18.572 23.4974 19.2134 22.856 20.0005 22.856Z"
                      fill="#323232"
                    ></path>
                    <path
                      d="M39.5814 34.7039L36.7243 31.8468C36.1657 31.2882 35.2628 31.2882 34.7043 31.8468C34.1457 32.4054 34.1457 33.3082 34.7043 33.8668L35.1229 34.2854H30.6829C32.0543 32.2411 32.8572 29.784 32.8572 27.1426V18.6155C32.8572 16.2284 30.9158 14.2856 28.5272 14.2856H27.1429V7.14278C27.1429 3.20425 23.9387 0 20.0002 0C16.0616 0 12.8574 3.20425 12.8574 7.14278V14.2856H11.4731C9.08598 14.2856 7.14314 16.2284 7.14314 18.6155V27.1426C7.14314 29.784 7.94599 32.2411 9.3174 34.2854H4.87745L5.29602 33.8668C5.85458 33.3082 5.85458 32.4054 5.29602 31.8468C4.73745 31.2882 3.8346 31.2882 3.27604 31.8468L0.418924 34.7039C-0.139641 35.2625 -0.139641 36.1653 0.418924 36.7239L3.27604 39.581C3.55461 39.8596 3.92032 39.9996 4.28603 39.9996C4.65174 39.9996 5.01745 39.8596 5.29602 39.581C5.85458 39.0225 5.85458 38.1196 5.29602 37.561L4.87745 37.1425H11.9374C14.1445 38.9253 16.9488 39.9996 20.0002 39.9996C23.053 39.9996 25.8558 38.9253 28.0629 37.1425H35.1229L34.7043 37.561C34.1457 38.1196 34.1457 39.0225 34.7043 39.581C34.9829 39.8596 35.3486 39.9996 35.7143 39.9996C36.08 39.9996 36.4457 39.8596 36.7243 39.581L39.5814 36.7239C40.1399 36.1653 40.1399 35.2625 39.5814 34.7039ZM15.7145 7.14278C15.7145 4.77995 17.6373 2.85711 20.0002 2.85711C22.363 2.85711 24.2858 4.77995 24.2858 7.14278V14.2856H15.7145V7.14278ZM10.0003 27.1426V18.6155C10.0003 17.8027 10.6602 17.1427 11.4731 17.1427H28.5272C29.3386 17.1427 30 17.8027 30 18.6155V27.1426C30 32.6568 25.513 37.1425 20.0002 37.1425C14.4859 37.1425 10.0003 32.6568 10.0003 27.1426Z"
                      fill="#323232"
                    ></path>
                  </svg>
                </i>
                <h3>Fixed Cost Model</h3>
                <p>Curated services for projects with defined requirements</p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-delay="600"
                className="yourProduct-module--serve_col--fd20d"
              >
                <i>
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_416_6886)">
                      <path
                        d="M27.1267 23.5318L21.5496 19.349V10.8285C21.5496 9.9718 20.8571 9.2793 20.0004 9.2793C19.1437 9.2793 18.4512 9.9718 18.4512 10.8285V20.1237C18.4512 20.6116 18.6805 21.0718 19.0709 21.363L25.2676 26.0106C25.5464 26.2198 25.8718 26.3205 26.1955 26.3205C26.668 26.3205 27.1328 26.1082 27.4365 25.6992C27.9509 25.0159 27.8115 24.0446 27.1267 23.5318Z"
                        fill="#323232"
                      ></path>
                      <path
                        d="M20 0C8.97133 0 0 8.97133 0 20C0 31.0287 8.97133 40 20 40C31.0287 40 40 31.0287 40 20C40 8.97133 31.0287 0 20 0ZM20 36.9016C10.6816 36.9016 3.09836 29.3184 3.09836 20C3.09836 10.6816 10.6816 3.09836 20 3.09836C29.3199 3.09836 36.9016 10.6816 36.9016 20C36.9016 29.3184 29.3184 36.9016 20 36.9016Z"
                        fill="#323232"
                      ></path>
                    </g>
                    <defs>
                      <clippath id="clip0_416_6886">
                        <rect width="40" height="40" fill="white"></rect>
                      </clippath>
                    </defs>
                  </svg>
                </i>
                <h3>Time &amp; material</h3>
                <p>Serves dynamic requirements &amp; long-term projects</p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="IntroducationHireAndriodDeveloper-module--introduction_section--435cf">
        <div className="container">
          <div className="IntroducationHireAndriodDeveloper-module--introduction_wrap--06d70">
            <div className="IntroducationHireAndriodDeveloper-module--introduction_swipe--b67f7">
              <span data-aos="fade-up" data-aos-delay="50">
                Hire dedicated developer
              </span>
              <h2 data-aos="fade-up" data-aos-delay="100">
                Hire Database Administrator
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Hire Database administrator from us to maintain and enhance your
                company’s database infrastructure. Our DBA’s responsibilities
                include installing and configuring databases, monitoring
                performance, ensuring data security and integrity, and fixing
                issues. You can ensure that your database is running
                efficiently, with the least amount of downtime and data loss
                possible, by hiring our DBA.
              </p>
              <button
                className="linkButtonForm-module--btn_red--1095e hire-btn"
                type="submit" onClick={handleButtonClick}
              >
                HIRE US
              </button>
            </div>
            <div
              className="IntroducationHireAndriodDeveloper-module--introduction_swipe--b67f7"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <div className="IntroducationHireAndriodDeveloper-module--developer_box--ce03a">
                <div className="IntroducationHireAndriodDeveloper-module--right_box--23c8a">
                  <picture>
                    <img
                                     src="/img/shahbaz.png"
                      alt="Shahbaz Ahmad Full stack Developer Angular React"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <div className="IntroducationHireAndriodDeveloper-module--innerdiv--bbc42">
                    <h5>Shahbaz Ahmad</h5>Skilled in managing and optimizing
                    database systems. Experienced in data modeling, performance
                    tuning, and backup/restore processes. Proficient in SQL and
                    database management tools.
                  </div>
                </div>
                <div className="IntroducationHireAndriodDeveloper-module--left_box--66307">
                  <span>Skill set</span>
                  <ul>
                    <li>
                      <div>Database design</div>
                    </li>
                    <li>
                      <div>Database modeling</div>
                    </li>
                    <li>
                      <div>Metadata management</div>
                    </li>
                    <li>
                      <div>Backup &amp; recovery</div>
                    </li>
                    <li>
                      <div>SQL code review</div>
                    </li>
                    <li>
                      <div>Data integrity</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div id="id1">
        <WriteToUs />
      </div>
    </div>
  );
};

export default FIreStore;
